// Faytex ordering + brand contact constants.
// Update these once and every "Order" CTA + footer will follow.

export const WHATSAPP_NUMBER = "233243247352"; // Ghana country code + local — no + sign, digits only
export const WHATSAPP_DISPLAY = "+233 0243 247 352";

// MTN Mobile Money merchant / short-code
export const MOMO_MERCHANT_ID = "980980";
export const MOMO_SHORT_CODE = "*170#";
export const MOMO_INSTRUCTIONS = [
  "Dial *170# on your MTN / Vodafone / AirtelTigo line.",
  "Select 'Pay a merchant'.",
  `Enter merchant ID: ${"980980"}.`,
  "Enter the amount and reference (product name).",
  "Confirm with your PIN — send the confirmation SMS to WhatsApp to complete your order.",
];

// Prefill WhatsApp message for a product order
export function whatsappOrderUrl(product) {
  const msg = product
    ? `Hello Faytex 👋 I would like to order:\n\n• ${product.name} (GH₵ ${product.price_ghs})\n\nPlease confirm availability and delivery.`
    : "Hello Faytex 👋 I would like to place an order.";
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;
}
